export default __webpack_public_path__ + "static/work-tool-c4aee5096ce13e92198958368cb5e635.jpg";